<template>
  <div>Verifying</div>
</template>

<script>
export default {
  name: 'GitHubCallback',
  data: () => ({
    token: null,
    emails: null
  }),
  async created() {
    try {
      const state = localStorage.githubState
      localStorage.removeItem('githubState')
      if (state !== this.$route.query.state) {
        throw new Error('State mismatch')
      }
      const code = this.$route.query.code
      const response = await this.$store.dispatch('token', { code })
      this.token = response.data
      await this.$store.dispatch('link', { githubToken: this.token.authentication.token })
      this.$router.push({ name: 'success-failure' })
    } catch (err) {
      this.$router.push({ name: 'success-failure', params: { err: true } })
    }
  }
}
</script>

<style scoped></style>
